<div [className]="commonService.chatExist? 'app-container' : 'app-container-wo'">
    <div class="content-container">
        <div class="row m-0">
            <div class="col-md-2 p-0"></div>
            <div class="col-sm-12 col-md-3 ps-0 pe-5">
                <div class="">
                    <div class="app-heading">{{'selfCare.title' | translate}}</div>
                    <div class="app-content-body font-15">
                        {{'selfCare.content' | translate}}
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-5 p-0 position-relative">
                <div class="content-container-frame">
                    <div>
                        <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabIndexChange($event)">
                            <ng-container *ngFor="let selfCare of selfCareList">
                                <mat-tab [label]="( selfCare.title | translate)">
                                    <div class="py-2 pe-2" [ngClass]="{ 'content-container-overflow':commonService.chatExist, 'content-container-overflow-wo': !commonService.chatExist}">
                                        <ng-container *ngFor="let tool of selfCare.tab">
                                            <div class="d-flex overflow-hidden mb-4 cursor justify-content-between" style="height: 57px;" (click)="showDetails(tool)">
                                                <div class="d-flex">
                                                    <div class="position-relative">
                                                        <img style="width: 76px;height: 57px;border-radius: 10px;" [src]="tool.thumbnail" />
                                                        <span class="material-icons play-btn" *ngIf="isYoutubeLink(tool.link)">
                                                            play_arrow
                                                        </span>
                                                    </div>
                                                    <div class="ps-4 p-1">
                                                        <div class="resource-card-content text-dark text-capitalize p-0 h-auto" [innerHTML]="(tool.title | translate)"></div>
                                                        <div class="card-text pt-2" style="height: auto;" [innerHTML]="(tool.content | translate)"></div>
                                                    </div>
                                                </div>
                                                <div class="ps-3 d-flex align-items-center">
                                                    <img [src]="commonService.resource.image.right_arrow" alt="">
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </mat-tab>
                            </ng-container>
                        </mat-tab-group>
                    </div>
                </div>
            </div>
            <div class="col-md-2 p-0"></div>
        </div>
    </div>
</div>


<!-- Modal -->
<div mdbModal #selfCareModal="mdb-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="false" [config]="{keyboard: false, ignoreBackdropClick: true}">
    <!-- <img class="w-50" style="color: #FFF2FC;" [src]="commonService.resource.image.modal_bg_image" alt=""> -->
    <div [innerHTML]="commonService.getModalBackgroundImg('#FFF2FC')"></div>
    <div class="row m-0">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-3 col-sm-12 p-0"></div>
        <div class="col-md-5 col-sm-12 p-0">
            <div class="modal-dialog chat-modal-dialog">
                <div class="modal-content" style="background-color: #FFF2FC;">
                    <div class="modal-body p-0 d-flex flex-column">
                        <div class="flex-1">
                            <div class="p-3 mt-2">
                                <span class="material-icons-outlined cursor" (click)="selfCareModal.hide()">
                                    arrow_back
                                </span>
                            </div>
                            <div class="px-4 overflow-auto" style="height: calc(100% - 110px);">
                                <div class="w-100 text-center">
                                    <iframe *ngIf="selectedTool.link" class="video-frame" [src]='selectedVideoUrl' frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                    <div class="m-auto" style="max-width: 425px;" *ngIf="!selectedTool.link">
                                        <img class="video-frame" [src]="selectedTool.thumbnail" alt="">
                                    </div>
                                </div>
                                <div class="py-3 m-auto" style="max-width: 425px;">
                                    <div class="resource-card-content text-dark text-capitalize font-22 p-0 " [innerHTML]="(selectedTool.title | translate)"></div>
                                    <div class="resource-sub-text pt-3 font-14" [ngClass]="{ 'fst-normal' : selectedTool?.subContent}" [innerHTML]="(selectedTool.content| translate)">
                                    </div>
                                    <div class="resource-sub-text pt-3 font-14" *ngIf="selectedTool?.subContent" [innerHTML]="(selectedTool.subContent| translate)">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="modal-footer border-0 m-0" style="padding: 0px 26px;">
                            <div class="w-100 justify-content-between gap-3">
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-md-2 p-0 "></div>
        </div>
    </div>
</div>